/**
 * Secret Service
 * AIDLC Administrative Frontend
 *
 * API calls for secrets inventory CRUD operations.
 */

import apiClient from './api';
import type { SecretEntry, SecretsSummary } from '../types/secret';

const SECRETS_PATH = '/secrets';

export async function getSecrets(params?: Record<string, string>): Promise<SecretEntry[]> {
  const query = new URLSearchParams();
  if (params) {
    Object.entries(params).forEach(([k, v]) => { if (v) query.set(k, v); });
  }
  const qs = query.toString();
  const response = await apiClient.get<SecretEntry[]>(`${SECRETS_PATH}${qs ? `?${qs}` : ''}`);
  return response.data;
}

export async function getSecretsSummary(): Promise<SecretsSummary> {
  const response = await apiClient.get<SecretsSummary>(`${SECRETS_PATH}/summary`);
  return response.data;
}

export async function getSecret(id: string): Promise<SecretEntry> {
  const response = await apiClient.get<SecretEntry>(`${SECRETS_PATH}/${id}`);
  return response.data;
}

export async function createSecret(data: Partial<SecretEntry>): Promise<SecretEntry> {
  const response = await apiClient.post<SecretEntry>(SECRETS_PATH, data);
  return response.data;
}

export async function updateSecret(id: string, updates: Partial<SecretEntry>): Promise<SecretEntry> {
  const response = await apiClient.put<SecretEntry>(`${SECRETS_PATH}/${id}`, updates);
  return response.data;
}

export async function deleteSecret(id: string): Promise<void> {
  await apiClient.delete(`${SECRETS_PATH}/${id}`);
}

export async function checkExpiry(): Promise<{
  checked: number;
  expiringSoon: string[];
  expired: string[];
  backlogCreated: string[];
}> {
  const response = await apiClient.post(`${SECRETS_PATH}/check-expiry`);
  return response.data;
}
